/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialBilibiliArchivesRequest = {
  mid: string;
  keywords?: string | undefined;
  orderby?: string | undefined;
  ps?: string | undefined;
  pn?: string | undefined;
};

export const GetSocialBilibiliArchivesRequest$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesRequest
> = z.object({
  keywords: z.string().describe("搜索关键词，可为空").optional(),
  mid: z.string().describe("B站用户的mid（用户ID）"),
  orderby: z.string().describe("排序方式。`pubdate`=最新发布，`views`=最多播放")
    .optional(),
  pn: z.string().describe("页码，默认1").optional(),
  ps: z.string().describe("每页条数，默认20").optional(),
});

export type GetSocialBilibiliArchivesInternalServerErrorDetails = {};

export const GetSocialBilibiliArchivesInternalServerErrorDetails$zodSchema:
  z.ZodType<GetSocialBilibiliArchivesInternalServerErrorDetails> = z.object({});

/**
 * 服务器错误
 */
export type GetSocialBilibiliArchivesInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliArchivesInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliArchivesInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetSocialBilibiliArchivesInternalServerErrorResponseBody> = z
    .object({
      code: z.string().optional(),
      details: z.lazy(() =>
        GetSocialBilibiliArchivesInternalServerErrorDetails$zodSchema
      ).optional(),
      message: z.string().optional(),
    }).describe("服务器错误");

export type GetSocialBilibiliArchivesNotFoundDetails = {};

export const GetSocialBilibiliArchivesNotFoundDetails$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesNotFoundDetails
> = z.object({});

/**
 * 用户不存在
 */
export type GetSocialBilibiliArchivesNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliArchivesNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliArchivesNotFoundResponseBody$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetSocialBilibiliArchivesNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("用户不存在");

export type GetSocialBilibiliArchivesBadRequestDetails = {};

export const GetSocialBilibiliArchivesBadRequestDetails$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesBadRequestDetails
> = z.object({});

/**
 * 参数错误
 */
export type GetSocialBilibiliArchivesBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetSocialBilibiliArchivesBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetSocialBilibiliArchivesBadRequestResponseBody$zodSchema:
  z.ZodType<GetSocialBilibiliArchivesBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetSocialBilibiliArchivesBadRequestDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("参数错误");

export type Video = {
  aid?: number | undefined;
  bvid?: string | undefined;
  title?: string | undefined;
  cover?: string | undefined;
  duration?: number | undefined;
  play_count?: number | undefined;
  publish_time?: number | undefined;
  create_time?: number | undefined;
  state?: number | undefined;
  is_ugc_pay?: number | undefined;
  is_interactive?: boolean | undefined;
};

export const Video$zodSchema: z.ZodType<Video> = z.object({
  aid: z.int().optional(),
  bvid: z.string().optional(),
  cover: z.string().optional(),
  create_time: z.int().optional(),
  duration: z.int().optional(),
  is_interactive: z.boolean().optional(),
  is_ugc_pay: z.int().optional(),
  play_count: z.int().optional(),
  publish_time: z.int().optional(),
  state: z.int().optional(),
  title: z.string().optional(),
});

/**
 * 成功！返回用户的投稿视频列表。
 */
export type GetSocialBilibiliArchivesResponseBody = {
  total?: number | undefined;
  page?: number | undefined;
  size?: number | undefined;
  videos?: Array<Video> | undefined;
};

export const GetSocialBilibiliArchivesResponseBody$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesResponseBody
> = z.object({
  page: z.int().optional(),
  size: z.int().optional(),
  total: z.int().optional(),
  videos: z.array(z.lazy(() => Video$zodSchema)).optional(),
}).describe("成功！返回用户的投稿视频列表。");

export type GetSocialBilibiliArchivesResponse =
  | GetSocialBilibiliArchivesResponseBody
  | GetSocialBilibiliArchivesBadRequestResponseBody
  | GetSocialBilibiliArchivesNotFoundResponseBody
  | GetSocialBilibiliArchivesInternalServerErrorResponseBody;

export const GetSocialBilibiliArchivesResponse$zodSchema: z.ZodType<
  GetSocialBilibiliArchivesResponse
> = z.union([
  z.lazy(() => GetSocialBilibiliArchivesResponseBody$zodSchema),
  z.lazy(() => GetSocialBilibiliArchivesBadRequestResponseBody$zodSchema),
  z.lazy(() => GetSocialBilibiliArchivesNotFoundResponseBody$zodSchema),
  z.lazy(() =>
    GetSocialBilibiliArchivesInternalServerErrorResponseBody$zodSchema
  ),
]);
